import { Component, OnInit, NgZone, ViewEncapsulation, ChangeDetectorRef } from '@angular/core';
import { ObjectivesService } from '../objectives.service';
import { NavigationService } from 'src/app/navigation/navigation.service';

@Component({
    selector: 'cv-objective-add-edit',
    templateUrl: './objective-add-edit.component.html',
    styleUrls: ['./objective-add-edit.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class ObjectiveAddEditComponent implements OnInit {
    cvDateFormat: string = CVDateFormat;
    showAssignTool: boolean = false;
    showRangeDropdown: boolean = false;
    showAssignToDropdown: boolean = false;
    assignTool: boolean = true;

    showEmailPopup: boolean = false;
    textAreaValue: string = "";
    emailFilterText: string = "";
    emailAlertTarget = null;
    tempEmailList = [];
    modalInstance = null;

    learnMoreModalOpen = false;

    private inputTimers: { [key: string]: any } = {};

    confirmationDialogOpen = 0;
    confirmIndex = 0;
    confirmObj = null;

    errorDialogOpen = 0;

    renderInputs = true;

    timeTypes = [
        { "val": 4, "name": "Hour" },
        { "val": 1, "name": "Day" },
        { "val": 2, "name": "Week" },
        { "val": 3, "name": "Month" }
    ];

    intervals = [
        { "val": 1, "name": 1 },
        { "val": 2, "name": 2 },
        { "val": 3, "name": 3 }
    ];

    positions = [
        [ [28, 153] ],
        [ [88, 239], [40, 48] ],
        [ [86, 239], [28, 153], [70, 14] ],
        [ [164, 241], [92, 239], [28, 157], [41, 47] ]
    ];

    positionsReverse = [
        [ [28, 91] ],
        [ [50, 33], [76, 233] ],
        [ [88, 5], [28, 91], [72, 231] ], 
        [ [51, 31], [28, 91], [72, 230], [161, 241] ]
    ];

    constructor(
        public objectiveService: ObjectivesService,
        private navigationService: NavigationService,
        //@Inject("$mdpDatePicker") private mdpDatePicker,
        public zone: NgZone,
        public cdr: ChangeDetectorRef,
    ) { }

    ngOnInit(): void {
        this.initiateMetricEventHandler();
    }

    applyFilter() { }

    stringToNumber(value: string) : number {
        return Number(value);
    }

    skipAlertLevel(label) {
        return (this.objectiveService.addEdit.editedObjectives[this.objectiveService.addEdit.selectedObjective].AssignedLevel == 6 ||
            this.objectiveService.addEdit.editedObjectives[this.objectiveService.addEdit.selectedObjective].AssignedType == 'rec' ||
            this.objectiveService.addEdit.editedObjectives[this.objectiveService.addEdit.selectedObjective].AssignedLevel <= label.GroupLevel);
    }

    quickAddCard(idx) {
        //ctrl.of.addEdit.selectedObjective = idx;
        this.objectiveService.selectObjective(idx);
        this.objectiveService.addEdit.editedObjectives[this.objectiveService.addEdit.selectedObjective].AssignedLevel = this.objectiveService.addEdit.editedObjectives.length - idx;
        this.objectiveService.addEdit.editedObjectives[this.objectiveService.addEdit.selectedObjective].AssignedType = this.objectiveService.addEdit.editedObjectives[0].AssignedType;
    }

    removeCard(idx, evt) {
        if (idx == 0 || idx == null)
            return;

        this.objectiveService.addEdit.editedObjectives[idx].AssignedLevel = 0;
        this.objectiveService.addEdit.editedObjectives[idx].ObjectiveDetails = [];

        if (this.objectiveService.addEdit.selectedObjective == idx)
            this.objectiveService.selectObjective(0);

        this.confirmationDialogOpen = 0;
    }

    cancelClick() {
        this.objectiveService.showAddEditObjective = false;

        this.objectiveService.showLandingHeader = true;

        this.objectiveService.addEdit.isEditing = false;
        this.objectiveService.addEdit.assignedGroups.assignOptions = null;
    }

    calculateDayMinValue(idx) {
        let newDayMinValue;
        let exp;

        if (this.objectiveService.addEdit.editedObjectives[this.objectiveService.addEdit.selectedObjective].ObjectiveDetails[idx - 1].dayMinValue != "" &&
            this.objectiveService.addEdit.editedObjectives[this.objectiveService.addEdit.selectedObjective].ObjectiveDetails[idx - 1].dayMinValue != null) {
            if (this.objectiveService.addEdit.editedObjectives[this.objectiveService.addEdit.selectedObjective].ObjectiveDetails[idx - 1].dayMinValue == 0)
                newDayMinValue = 0;
            else {
                if (this.objectiveService.addEdit.editedObjectives[this.objectiveService.addEdit.selectedObjective].ObjectiveDetails[idx - 1].dayMinValue % 1 == 0) {
                    newDayMinValue = (this.objectiveService.addEdit.editedObjectives[this.objectiveService.addEdit.selectedObjective].ObjectiveDetails[idx - 1].dayMinValue * 100 - 1) / 100;

                    if (this.objectiveService.addEdit.editedObjectives[this.objectiveService.addEdit.selectedObjective].ObjectiveDetails[idx - 1].dayMinValue.toString().includes(".")) {
                        exp = this.objectiveService.addEdit.editedObjectives[this.objectiveService.addEdit.selectedObjective].ObjectiveDetails[idx - 1].dayMinValue.toString().split(".")[1].length;

                        if (exp != undefined && exp > 2) {
                            newDayMinValue = (this.objectiveService.addEdit.editedObjectives[this.objectiveService.addEdit.selectedObjective].ObjectiveDetails[idx - 1].dayMinValue * Math.pow(10, exp) - 1) / Math.pow(10, exp);
                            newDayMinValue = newDayMinValue.toFixed(exp);
                        }
                    }
                }
                else {
                    exp = this.objectiveService.addEdit.editedObjectives[this.objectiveService.addEdit.selectedObjective].ObjectiveDetails[idx - 1].dayMinValue.toString().split(".")[1].length;

                    if (exp > 2) {
                        newDayMinValue = (this.objectiveService.addEdit.editedObjectives[this.objectiveService.addEdit.selectedObjective].ObjectiveDetails[idx - 1].dayMinValue * Math.pow(10, exp) - 1) / Math.pow(10, exp);
                        newDayMinValue = newDayMinValue.toFixed(exp);
                    }
                    else {
                        newDayMinValue = (this.objectiveService.addEdit.editedObjectives[this.objectiveService.addEdit.selectedObjective].ObjectiveDetails[idx - 1].dayMinValue * 100 - 1) / 100;
                        newDayMinValue = newDayMinValue.toFixed(2);
                    }
                }
            }
        }
        else
            newDayMinValue = "";

        return newDayMinValue;
    }

    calculateWeekMinValue(idx) {
        let newWeekMinValue;
        let exp;

        if (this.objectiveService.addEdit.editedObjectives[this.objectiveService.addEdit.selectedObjective].ObjectiveDetails[idx - 1].weekMinValue != "" &&
            this.objectiveService.addEdit.editedObjectives[this.objectiveService.addEdit.selectedObjective].ObjectiveDetails[idx - 1].weekMinValue != null) {
            if (this.objectiveService.addEdit.editedObjectives[this.objectiveService.addEdit.selectedObjective].ObjectiveDetails[idx - 1].weekMinValue == 0)
                newWeekMinValue = 0;
            else {
                if (this.objectiveService.addEdit.editedObjectives[this.objectiveService.addEdit.selectedObjective].ObjectiveDetails[idx - 1].weekMinValue % 1 == 0) {
                    newWeekMinValue = (this.objectiveService.addEdit.editedObjectives[this.objectiveService.addEdit.selectedObjective].ObjectiveDetails[idx - 1].weekMinValue * 100 - 1) / 100;

                    if (this.objectiveService.addEdit.editedObjectives[this.objectiveService.addEdit.selectedObjective].ObjectiveDetails[idx - 1].weekMinValue.toString().includes(".")) {
                        exp = this.objectiveService.addEdit.editedObjectives[this.objectiveService.addEdit.selectedObjective].ObjectiveDetails[idx - 1].weekMinValue.toString().split(".")[1].length;

                        if (exp != undefined && exp > 2) {
                            newWeekMinValue = (this.objectiveService.addEdit.editedObjectives[this.objectiveService.addEdit.selectedObjective].ObjectiveDetails[idx - 1].weekMinValue * Math.pow(10, exp) - 1) / Math.pow(10, exp);
                            newWeekMinValue = newWeekMinValue.toFixed(exp);
                        }
                    }
                }
                else {
                    exp = this.objectiveService.addEdit.editedObjectives[this.objectiveService.addEdit.selectedObjective].ObjectiveDetails[idx - 1].weekMinValue.toString().split(".")[1].length;

                    if (exp > 2) {
                        newWeekMinValue = (this.objectiveService.addEdit.editedObjectives[this.objectiveService.addEdit.selectedObjective].ObjectiveDetails[idx - 1].weekMinValue * Math.pow(10, exp) - 1) / Math.pow(10, exp);
                        newWeekMinValue = newWeekMinValue.toFixed(exp);
                    }
                    else {
                        newWeekMinValue = (this.objectiveService.addEdit.editedObjectives[this.objectiveService.addEdit.selectedObjective].ObjectiveDetails[idx - 1].weekMinValue * 100 - 1) / 100;
                        newWeekMinValue = newWeekMinValue.toFixed(2);
                    }
                }
            }
        }
        else
            newWeekMinValue = "";

        return newWeekMinValue;
    }

    calculateMonthMinValue(idx) {
        let newMonthMinValue;
        let exp;

        if (this.objectiveService.addEdit.editedObjectives[this.objectiveService.addEdit.selectedObjective].ObjectiveDetails[idx - 1].monthMinValue != "" &&
            this.objectiveService.addEdit.editedObjectives[this.objectiveService.addEdit.selectedObjective].ObjectiveDetails[idx - 1].monthMinValue != null) {
            if (this.objectiveService.addEdit.editedObjectives[this.objectiveService.addEdit.selectedObjective].ObjectiveDetails[idx - 1].monthMinValue == 0)
                newMonthMinValue = 0;
            else {
                if (this.objectiveService.addEdit.editedObjectives[this.objectiveService.addEdit.selectedObjective].ObjectiveDetails[idx - 1].monthMinValue % 1 == 0) {
                    newMonthMinValue = (this.objectiveService.addEdit.editedObjectives[this.objectiveService.addEdit.selectedObjective].ObjectiveDetails[idx - 1].monthMinValue * 100 - 1) / 100;

                    if (this.objectiveService.addEdit.editedObjectives[this.objectiveService.addEdit.selectedObjective].ObjectiveDetails[idx - 1].monthMinValue.toString().includes(".")) {
                        exp = this.objectiveService.addEdit.editedObjectives[this.objectiveService.addEdit.selectedObjective].ObjectiveDetails[idx - 1].monthMinValue.toString().split(".")[1].length;

                        if (exp != undefined && exp > 2) {
                            newMonthMinValue = (this.objectiveService.addEdit.editedObjectives[this.objectiveService.addEdit.selectedObjective].ObjectiveDetails[idx - 1].monthMinValue * Math.pow(10, exp) - 1) / Math.pow(10, exp);
                            newMonthMinValue = newMonthMinValue.toFixed(exp);
                        }
                    }
                }
                else {
                    exp = this.objectiveService.addEdit.editedObjectives[this.objectiveService.addEdit.selectedObjective].ObjectiveDetails[idx - 1].monthMinValue.toString().split(".")[1].length;

                    if (exp > 2) {
                        newMonthMinValue = (this.objectiveService.addEdit.editedObjectives[this.objectiveService.addEdit.selectedObjective].ObjectiveDetails[idx - 1].monthMinValue * Math.pow(10, exp) - 1) / Math.pow(10, exp);
                        newMonthMinValue = newMonthMinValue.toFixed(exp);
                    }
                    else {
                        newMonthMinValue = (this.objectiveService.addEdit.editedObjectives[this.objectiveService.addEdit.selectedObjective].ObjectiveDetails[idx - 1].monthMinValue * 100 - 1) / 100;
                        newMonthMinValue = newMonthMinValue.toFixed(2);
                    }
                }
            }
        }
        else
            newMonthMinValue = "";

        return newMonthMinValue;
    }

    async saveObjective() {
        // Add validation here
        if (this.objectiveService.addEdit.MetricID == 0 || this.objectiveService.addEdit.MetricID == null) {
            this.errorDialogOpen = 1;
            return;
        }

        // Must select an emp and rec group for quota metrics
        if (this.objectiveService.addEdit.MetricObjectiveType == 0 && (this.objectiveService.addEdit.assignedGroups.emp.length == 0 && !this.objectiveService.addEdit.assignedGroups.empAssignAll) || (this.objectiveService.addEdit.assignedGroups.rec.length == 0 && !this.objectiveService.addEdit.assignedGroups.recAssignAll)) {
            this.errorDialogOpen = 2;
            return;
        }

        for (let editedObjective of this.objectiveService.addEdit.editedObjectives) {
            if (editedObjective.AssignedLevel == 0)
                continue;

            let gaugeInputVerification = this.verifyGaugeInputs(editedObjective);
            if (gaugeInputVerification > 0) {
                this.errorDialogOpen = gaugeInputVerification;
                return;
            }
        }

        for (let editedObjective of this.objectiveService.addEdit.editedObjectives) {
            if (editedObjective.AssignedLevel == 0)
                continue;

            for (let alertsSubList of editedObjective.AlertsList) {
                for (let alert of alertsSubList) {
                    const hasOtherEmails = alert.OtherEmailsList.length > 0 && alert.OtherEmailsList[0] != "";
                    if (!alert.SendEmail && !alert.SendSystemNote && !hasOtherEmails) {
                        // No send method set
                        this.errorDialogOpen = 5;
                        return;
                    }

                    if (!alert.SendToLevel || !alert.SendToRole) {
                        this.errorDialogOpen = 9;
                        return;
                    }
                }
            }
        }

        let changeFound = false;
        let count = 0;
        for (let editedObjective of this.objectiveService.addEdit.editedObjectives) {
            if (editedObjective.AssignedLevel != 0)
                count++;
            else
                continue;

            let found = false;
            for (let originalObjective of this.objectiveService.addEdit.originalObjectives) {
                if (editedObjective.ObjectiveID == originalObjective.ObjectiveID) {
                    found = true;

                    if (!angular.equals(editedObjective, originalObjective))
                        changeFound = true;
                    break;
                }
            }

            if (!found)
                changeFound = true;

            if (changeFound)
                break;
        }

        if (!changeFound) {
            if (this.objectiveService.addEdit.assignedGroups.emp.length != this.objectiveService.addEdit.originalAssignedGroups.emp.length ||
                this.objectiveService.addEdit.assignedGroups.rec.length != this.objectiveService.addEdit.originalAssignedGroups.rec.length ||
                this.objectiveService.addEdit.assignedGroups.attr.length != this.objectiveService.addEdit.originalAssignedGroups.attr.length) {
                changeFound = true;
            }
        }

        if (!changeFound) {
            for (let i = 0; i < this.objectiveService.addEdit.assignedGroups.emp.length; i++) {
                if (this.objectiveService.addEdit.assignedGroups.emp[i].GroupID != this.objectiveService.addEdit.originalAssignedGroups.emp[i].GroupID) {
                    changeFound = true;
                    break;
                }
            }
        }

        if (!changeFound) {
            for (let i = 0; i < this.objectiveService.addEdit.assignedGroups.rec.length; i++) {
                if (this.objectiveService.addEdit.assignedGroups.rec[i].GroupID != this.objectiveService.addEdit.originalAssignedGroups.rec[i].GroupID) {
                    changeFound = true;
                    break;
                }
            }
        }

        if (!changeFound) {
            for (let i = 0; i < this.objectiveService.addEdit.assignedGroups.attr.length; i++) {
                if (this.objectiveService.addEdit.assignedGroups.attr[i].AgentAttributeID != this.objectiveService.addEdit.originalAssignedGroups.attr[i].AgentAttributeID ||
                    this.objectiveService.addEdit.assignedGroups.attr[i].AttributeValueID != this.objectiveService.addEdit.originalAssignedGroups.attr[i].AttributeValueID) {
                    changeFound = true;
                    break;
                }
            }
        }

        // If they added or removed a card
        if (count != this.objectiveService.addEdit.originalObjectives.length)
            changeFound = true;

        if (changeFound) {
            // Convert HH:MM:SS types back to their numerical values
            if (this.objectiveService.addEdit.MetricValueType == 3 && this.objectiveService.addEdit.MetricValueTimeType == 4) {

                for(let objCard of this.objectiveService.addEdit.editedObjectives) {
                    for (let detail of objCard.ObjectiveDetails) {
                        detail.dayMinValue = this.objectiveService.getSecondsFromTimeType(detail.dayMinValue);

                        if (detail.weekMinValue)
                            detail.weekMinValue = this.objectiveService.getSecondsFromTimeType(detail.weekMinValue);

                        if (detail.monthMinValue)
                            detail.monthMinValue = this.objectiveService.getSecondsFromTimeType(detail.monthMinValue);
                    }
                } 
            }

            const result = await this.objectiveService.SaveObjectives(this.objectiveService.addEdit.assignedGroups);
            this.objectiveService.showAddEditObjective = false;

            for (let i = 0; i < this.objectiveService.addEdit.editedObjectives.length; i++) {
                if (i != 0)
                    this.objectiveService.addEdit.editedObjectives[i].GroupingID = this.objectiveService.addEdit.editedObjectives[0].ObjectiveID;

                let objFound = false;
                for (let j = 0; j < this.objectiveService.loadedObjectives.length; j++) {
                    if (this.objectiveService.loadedObjectives[j].combinedObj.ObjectiveID == this.objectiveService.addEdit.editedObjectives[i].ObjectiveID) {
                        if (this.objectiveService.addEdit.editedObjectives[i].AssignedLevel == 0)
                            this.objectiveService.loadedObjectives.splice(j, 1);
                        else {
                            this.objectiveService.addEdit.editedObjectives[i].ObjectiveID = result.data[i];
                            this.objectiveService.loadedObjectives[j].combinedObj = angular.copy(this.objectiveService.addEdit.editedObjectives[i]);
                            this.objectiveService.loadedObjectives[j].assignments = angular.copy(this.objectiveService.addEdit.assignedGroups);
                            this.objectiveService.loadedObjectives[j].MetricID = this.objectiveService.addEdit.MetricID;
                        }

                        objFound = true;
                        break;
                    }
                }

                if (!objFound) {
                    this.objectiveService.addEdit.editedObjectives[i].ObjectiveID = result.data[i];

                    if (this.objectiveService.addEdit.editedObjectives[i].ObjectiveID != 0) {
                        let newObj = {
                            'combinedObj': angular.copy(this.objectiveService.addEdit.editedObjectives[i]),
                            'assignments': angular.copy(this.objectiveService.addEdit.assignedGroups),
                            'MetricID': this.objectiveService.addEdit.MetricID
                        }

                        this.objectiveService.loadedObjectives.push(newObj);
                        this.objectiveService.setGroupObjByMetric();
                    }
                }
            }

            this.objectiveService.addEdit.assignedGroups = []

            this.objectiveService.showLandingHeader = true;
        }
        else {
            this.objectiveService.showAddEditObjective = false;
            this.objectiveService.showLandingHeader = true;
        }

        this.objectiveService.addEdit.isEditing = false;
        this.objectiveService.addEdit.assignedGroups.assignOptions = null;
    }

    addAlert() {
        let newAlert = {
            "IntervalTime": 1,
            "IntervalTimeType": this.objectiveService.addEdit.MetricIsRealtime ? 5 : 1,
            "SendEmail": false,
            "SendSystemNote": this.objectiveService.addEdit.MetricIsRealtime,
            "OtherEmailsList": [],
            "OtherEmails": "",
            "SendToLevel": null,
            "SendToRole": 0,
            "ShowAllEmail": false,
            "Active": true
        };

        if (this.objectiveService.addEdit.editedObjectives[this.objectiveService.addEdit.selectedObjective].AlertsList == null)
            this.objectiveService.addEdit.editedObjectives[this.objectiveService.addEdit.selectedObjective].AlertsList = [[], [], []];

        // "val": 1, "name": "Day", "val": 2, "name": "Week", "val": 3, "name": "Month"
        if (this.objectiveService.addEdit.MetricObjectiveType == 0) { // if quota metric is chosen then set the type to match the selected tab, if this is not the case they will get small intervals that will almost always come back red.
            switch (this.objectiveService.selectedValueTab) {
                case 'day':
                    this.objectiveService.addEdit.editedObjectives[this.objectiveService.addEdit.selectedObjective].AlertsList[0].push(newAlert);
                    break;
                case 'week':
                    newAlert.IntervalTimeType = 2;
                    this.objectiveService.addEdit.editedObjectives[this.objectiveService.addEdit.selectedObjective].AlertsList[1].push(newAlert);
                    break;
                case 'month':
                    newAlert.IntervalTimeType = 3;
                    this.objectiveService.addEdit.editedObjectives[this.objectiveService.addEdit.selectedObjective].AlertsList[2].push(newAlert);
                    break;
            }
        }
        else
            this.objectiveService.addEdit.editedObjectives[this.objectiveService.addEdit.selectedObjective].AlertsList[0].push(newAlert);
    }

    confirmRemoveAlert(alert) {
        let idx = -1;
        let lst = -1;

        for (let i = 0; i < this.objectiveService.addEdit.editedObjectives[this.objectiveService.addEdit.selectedObjective].AlertsList.length; i++) {
            if (this.objectiveService.addEdit.editedObjectives[this.objectiveService.addEdit.selectedObjective].AlertsList[i].indexOf(alert) > -1) {
                idx = this.objectiveService.addEdit.editedObjectives[this.objectiveService.addEdit.selectedObjective].AlertsList[i].indexOf(alert);
                lst = i;
                break;
            }
        }

        this.objectiveService.addEdit.editedObjectives[this.objectiveService.addEdit.selectedObjective].AlertsList[lst].splice(idx, 1);

        this.confirmationDialogOpen = 0;
    }

    removeExtraEmail(alert, index) {
        alert.OtherEmailsList.splice(index, 1);

        // parse list here
        alert.OtherEmails = "";
        for (let i = 0; i < alert.OtherEmailsList.length; i++) {
            alert.OtherEmails += alert.OtherEmailsList[i];
            if (i < alert.OtherEmailsList.length - 1)
                alert.OtherEmails += ",";
        }
    }

    isValidEmailAddress(emailAddress) {
        let pattern = new RegExp(/^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/);
        if (emailAddress.length == 0)
            return true;
        return pattern.test(emailAddress);
    }

    parseEmailList() {
        if (this.textAreaValue == "")
            return;

        let emailArray = this.textAreaValue.split(',');
        let invalidArray = new Array();

        for (let i = 0; i < emailArray.length; i++) {
            // Validate each email address
            let emailAddress = emailArray[i].replace(/\s+/g, ""); // Remove all whitespace
            if (!this.isValidEmailAddress(emailAddress)) {
                invalidArray.push(emailAddress);
                continue;
            }

            if (emailAddress == "") { // Throw out empty emails
                emailArray.splice(i, 1);
                i--;
                continue;
            }

            emailArray[i] = emailAddress;
        }

        if (invalidArray.length > 0) {
            this.errorDialogOpen = 6;
            return;
        }
        else
            this.textAreaValue = "";

        for (let email of emailArray) {
            let duplicate = false;
            for (let tempEmail of this.tempEmailList) {
                if (email == tempEmail)
                    duplicate = true;
            }

            if (!duplicate)
                this.tempEmailList.push(email);
        }
    }

    filterEmails(email) {
        let match_name_filter = false;

        // Null? seems bad...
        if (email == null)
            return false;

        // Name match
        if (this.emailFilterText != "") {
            if (email.toLowerCase().indexOf(this.emailFilterText.toLowerCase()) > -1)
                match_name_filter = true;
        }
        else
            match_name_filter = true;

        return match_name_filter;
    }

    removeTempEmail(email) {
        if (this.tempEmailList.indexOf(email != -1))
            this.tempEmailList.splice(this.tempEmailList.indexOf(email), 1);
    }

    saveEmailList() {
        if (this.textAreaValue != "")
            this.confirmationDialogOpen = 2;
        else
            this.confirmSaveEmails();
    }

    confirmSaveEmails() {
        this.emailAlertTarget.OtherEmailsList = angular.copy(this.tempEmailList);

        // parse list here
        this.emailAlertTarget.OtherEmails = "";
        for (let i = 0; i < this.emailAlertTarget.OtherEmailsList.length; i++) {
            this.emailAlertTarget.OtherEmails += this.emailAlertTarget.OtherEmailsList[i];
            if (i < this.emailAlertTarget.OtherEmailsList.length - 1) this.emailAlertTarget.OtherEmails += ",";
        }

        this.confirmationDialogOpen = 0;
        this.closeEmailPopup();
    }

    editAssignType() {
        if ((this.objectiveService.addEdit.assignedGroups.emp != null && this.objectiveService.addEdit.assignedGroups.emp.length != 0) ||
            (this.objectiveService.addEdit.assignedGroups.rec != null && this.objectiveService.addEdit.assignedGroups.rec.length != 0)) {
            this.confirmationDialogOpen = 3;
        }
    }

    confirmEditAssignType() {
        let tempAssignments = angular.copy(this.objectiveService.addEdit.assignedGroups);
        tempAssignments.emp = null;
        tempAssignments.rec = null;
        tempAssignments.attr = null;

        this.objectiveService.addEdit.assignedGroups = tempAssignments;

        this.confirmationDialogOpen = 0;
    }

    denyEditAssignType() {
        this.confirmationDialogOpen = 0;

        if (this.objectiveService.addEdit.assignedGroups.assignOptions.coreAssignAtOption == "specific")
            this.objectiveService.addEdit.assignedGroups.assignOptions.coreAssignAtOption = "parent";
        else
            this.objectiveService.addEdit.assignedGroups.assignOptions.coreAssignAtOption = "specific";
    }

    metricButtonClick() {
        $('#ContentPlaceHolderMain_ObjectiveNewMetricSelector_metricSelectorContainer').find('.showMetricSelectorModule').trigger("click");

        // Since the metric selector is not handling the removal of metrics from the list, 
        // this loop unselects everything that is not selected
        let $metricsSelected = $('.metricSelectorModule.msmClone').find('.MetricSelector:not(.hidden)');
        $metricsSelected.removeClass('MetricSelectorSelected');

        if (this.objectiveService.addEdit.MetricID != 0) {
            for (let metricSelected of $metricsSelected) {
                if (this.objectiveService.addEdit.MetricID == metricSelected.attributes["metricid"].value)
                    $(metricSelected).addClass('MetricSelectorSelected');
            }
        }

        let navService = this.navigationService;
        let objService = this.objectiveService;
        this.navigationService.showOverlay = true;

        $('body').on("click.ObjectiveNewMetric", ".metricSelectorModule", function (e) {
            navService.showOverlay = false;

            $('body').off("click.ObjectiveNewMetric");

            objService.addEdit.selectedRange = null;

            // This is mostly for looks; for reasons not entirely understood, attempting to set the palette at this stage won't work as some aspects of it will be reversed
            // by the time groups are assigned and actual range editing can begin. Therefore, this just places the appropriate palette into the (disabled) dropdown box.
            let threeRangePalette = objService.colorPalettes.find(o => o.LevelCount == 3);
            objService.addEdit.selectedRange = angular.copy(threeRangePalette ?? objService.colorPalettes[0]);
        });
    }

    setSelectedRange(palette) {
        this.objectiveService.addEdit.selectedRange = angular.copy(palette);

        for (let editedObjective of this.objectiveService.addEdit.editedObjectives) {
            editedObjective.ObjectivePaletteID = palette.ObjectivePaletteID;
            editedObjective.ObjectiveDetails = [];

            for (let j = 0; j < this.objectiveService.addEdit.selectedRange.ObjectiveColors.length - 1; j++) {
                editedObjective.ObjectiveDetails.push({ "dayMinValue": null, "weekMinValue": null, "monthMinValue": null });
            }
        }

        this.showRangeDropdown = false;
        $(document).off("click.ObjectivesRangePicker");
    }

    toggleRangeDropdown(evt) {
        evt.stopPropagation();

        if (this.showRangeDropdown) {
            window.setTimeout(() => {
                this.showRangeDropdown = false;
            }, 0);

            $(document).off("click.ObjectivesRangePicker");
        }
        else {
            this.showRangeDropdown = true;

            $(document).on("click.ObjectivesRangePicker", (e) => {
                this.zone.run(() => {
                    this.toggleRangeDropdown(e);
                });
            });
        }
    }

    AddEmails(alert) {
        this.emailAlertTarget = alert;
        this.tempEmailList = angular.copy(this.emailAlertTarget.OtherEmailsList);
        this.textAreaValue = "";
        this.showEmailPopup = true;
        $("body").addClass("stopScrolling");
    }

    closeEmailPopup() {
        this.showEmailPopup = false;
        this.emailAlertTarget = null;
        this.textAreaValue = "";
        this.emailFilterText = "";
        $("body").removeClass("stopScrolling");
    }

    removeAlert(index) {
        this.confirmationDialogOpen = 4;
        this.confirmIndex = index;
    }

    toggleAssignToDropdown(evt) {
        evt.stopPropagation();

        if (this.showAssignToDropdown) {
            window.setTimeout(() => {
                this.showAssignToDropdown = false;
            }, 0);
            $(document).off("click.ObjectivesAssignToPicker");
        }
        else {
            this.showAssignToDropdown = true;

            $(document).on("click.ObjectivesAssignToPicker", (e) => {
                this.zone.run(() => {
                    this.toggleAssignToDropdown(e);
                });
            });
        }
    }

    selectAssignTo(obj) {
        if ((this.objectiveService.addEdit.assignedGroups.emp != null && this.objectiveService.addEdit.assignedGroups.emp.length != 0) ||
            (this.objectiveService.addEdit.assignedGroups.rec != null && this.objectiveService.addEdit.assignedGroups.rec.length != 0)) {
            this.confirmationDialogOpen = 5;
            this.confirmObj = obj;
            return;
        }

        this.refreshAssignTool();

        if (obj.BaseGroupType == 0) { // Emp
            this.objectiveService.addEdit.assignedGroups.coreAssignAtLevel = obj.GroupLevel;
            this.objectiveService.addEdit.assignedGroups.coreAssignAtType = "emp";

            this.objectiveService.addEdit.assignedGroups.assignOptions.coreAssignAtLevel = obj.GroupLevel;
            this.objectiveService.addEdit.assignedGroups.assignOptions.coreAssignAtType = "emp";
            if (obj.GroupLevel == this.objectiveService.empGroupLabels.length)
                this.objectiveService.addEdit.assignedGroups.assignOptions.coreAssignAtOption = 'specific';

            this.objectiveService.addEdit.editedObjectives = [];
            this.objectiveService.addNewObjective(this.objectiveService.addEdit.assignedGroups.coreAssignAtLevel, this.objectiveService.addEdit.assignedGroups.coreAssignAtType);

            for (let i = this.objectiveService.addEdit.assignedGroups.coreAssignAtLevel - 1; i > 0; i--) {
                this.objectiveService.addQuickLevelObjective();
            }

            this.objectiveService.selectObjective(0);
        }
        else {
            this.objectiveService.addEdit.assignedGroups.coreAssignAtLevel = obj.GroupLevel;
            this.objectiveService.addEdit.assignedGroups.coreAssignAtType = "rec";

            this.objectiveService.addEdit.assignedGroups.assignOptions.coreAssignAtLevel = obj.GroupLevel;
            this.objectiveService.addEdit.assignedGroups.assignOptions.coreAssignAtType = "rec";
            if (obj.GroupLevel == this.objectiveService.recGroupLabels.length)
                this.objectiveService.addEdit.assignedGroups.assignOptions.coreAssignAtOption = 'specific';

            this.objectiveService.addEdit.editedObjectives = [];
            this.objectiveService.addNewObjective(this.objectiveService.addEdit.assignedGroups.coreAssignAtLevel, this.objectiveService.addEdit.assignedGroups.coreAssignAtType);

            for (let i = this.objectiveService.addEdit.assignedGroups.coreAssignAtLevel - 1; i > 0; i--) {
                this.objectiveService.addQuickLevelObjective();
            }

            this.objectiveService.selectObjective(0);
        }

        this.showAssignToDropdown = false;
        $(document).off("click.ObjectivesAssignToPicker");
    }

    confirmAssignTo(obj) {
        let tempAssignments = angular.copy(this.objectiveService.addEdit.assignedGroups);
        tempAssignments.emp = null;
        tempAssignments.rec = null;
        tempAssignments.attr = null;

        this.objectiveService.addEdit.assignedGroups = tempAssignments;

        this.selectAssignTo(obj);

        this.confirmationDialogOpen = 0;
    }

    initiateMetricEventHandler() {
        $(document).off("metricClicked.Objectives");
        $(document).on("metricClicked.Objectives", (e: any) => {
            this.zone.run(async () => {
                if (this.objectiveService.addEdit.MetricID != e.mID) {
                    this.objectiveService.addEdit.MetricID = e.mID;
                }
                else {
                    return;
                }

                if (this.objectiveService.addEdit.MetricID == 0) {
                    window.setTimeout(() => {
                        this.objectiveService.addEdit.MetricName = "";
                        this.objectiveService.addEdit.MetricObjectiveType = null;
                        this.objectiveService.addEdit.MetricValueType = null;
                        this.objectiveService.addEdit.MetricDirection = null;
                        this.objectiveService.addEdit.MetricIsRealtime = null;
                    }, 0);
                }
                else {
                    const result = await this.objectiveService.LoadMetricObjectiveType(this.objectiveService.addEdit.MetricID);

                    // MetricObjectiveType: Quota = 0, Normalized = 1
                    // MetricValueType/NumericType: Currency = 0, Number = 1, Percent = 2, Time = 3
                    // MetricValueType/TimeType: None = 0, Second = 1, Minute = 2, Hour = 3, Time = 4
                    if (this.objectiveService.addEdit.MetricObjectiveType != result.MetricObjectiveType) { // if switching between normalized and quota types
                        this.objectiveService.addEdit.editedObjectives = [];

                        this.objectiveService.addEdit.assignedGroups = [];
                        this.objectiveService.addEdit.assignedGroups.coreAssignAtLevel = null;
                        this.objectiveService.addEdit.assignedGroups.coreAssignAtType = null;
                        this.objectiveService.addEdit.assignedGroups.assignOptions = {};

                        if (result.MetricObjectiveType == 1) {
                            this.objectiveService.addEdit.assignedGroups.coreAssignAtLevel = 6;
                            this.objectiveService.addEdit.assignedGroups.coreAssignAtType = "emp";

                            this.objectiveService.addEdit.assignedGroups.assignOptions.coreAssignAtLevel = 6;
                            this.objectiveService.addEdit.assignedGroups.assignOptions.coreAssignAtType = "emp";
                            this.objectiveService.addEdit.assignedGroups.assignOptions.coreAssignAtOption = "normal";
                        }
                        else if (result.MetricObjectiveType == 0) {
                            this.objectiveService.addEdit.assignedGroups.coreAssignAtLevel = 1;
                            this.objectiveService.addEdit.assignedGroups.coreAssignAtType = "emp";

                            this.objectiveService.addEdit.assignedGroups.assignOptions.coreAssignAtLevel = 1;
                            this.objectiveService.addEdit.assignedGroups.assignOptions.coreAssignAtType = "emp";
                            this.objectiveService.addEdit.assignedGroups.assignOptions.coreAssignAtOption = "parent";
                        }

                        this.objectiveService.addEdit.selectedObjective = 0;
                    }

                    this.objectiveService.addEdit.MetricName = result.MetricName;
                    this.objectiveService.addEdit.MetricObjectiveType = result.MetricObjectiveType;
                    this.objectiveService.addEdit.MetricValueType = result.NumericType;
                    this.objectiveService.addEdit.MetricValueTimeType = result.TimeType;
                    this.objectiveService.addEdit.MetricDirection = result.Direction;
                    this.objectiveService.addEdit.MetricIsRealtime = result.IsRealtime;
                }

                this.objectiveService.selectedValueTab = 'day';
            });
        });
    }

    getObjectiveColor(color, index) {
        if (this.objectiveService.addEdit.MetricDirection == 0)
            return color.HexColor;
        else
            return this.objectiveService.addEdit.selectedRange.ObjectiveColors[this.objectiveService.addEdit.selectedRange.ObjectiveColors.length - (index + 1)].HexColor;
    }

    getGroupTypeName() {
        if (this.objectiveService.addEdit.assignedGroups.coreAssignAtType == 'emp')
            return ' ' + this.objectiveService.empGroupLabels[this.objectiveService.empGroupLabels.length - this.objectiveService.addEdit.assignedGroups.coreAssignAtLevel].GroupTypeName + ' ';
        else
            return ' ' + this.objectiveService.recGroupLabels[this.objectiveService.recGroupLabels.length - this.objectiveService.addEdit.assignedGroups.coreAssignAtLevel].GroupTypeName + ' ';
    }

    /**
     * Gets the coordinates for the input boxes to go around the gauge images.
     * @param top Set to true to get the value for the "top" property, false to get the "left" property
     * @param index The index value of the input box to get the dimensions for
     */
    getObjectiveFieldPosition(dimension, index) {
        let positionsArray;
        if (this.objectiveService.addEdit.MetricDirection == 0)
            positionsArray = this.positionsReverse[this.objectiveService.addEdit.selectedRange.LevelCount - 2];
        else
            positionsArray = this.positions[this.objectiveService.addEdit.selectedRange.LevelCount - 2];

        if (positionsArray.length <= index)
            return;

        return positionsArray[index][dimension ? 0 : 1] + "px";
    }

    /**
     * Fills the ranges for Week and Month based on those inputted for Day.
     */
    public autoFill(): void {
        for (let objective of this.objectiveService.addEdit.editedObjectives[this.objectiveService.addEdit.selectedObjective].ObjectiveDetails) {
            let dayValue = this.objectiveService.convertFormattedValueToNumber(objective.dayMinValue, this.objectiveService.addEdit.MetricValueType, this.objectiveService.addEdit.MetricValueTimeType);

            objective.weekMinValue = this.objectiveService.getFormattedValue(dayValue * 5, this.objectiveService.addEdit.MetricValueType, this.objectiveService.addEdit.MetricValueTimeType);
            objective.monthMinValue = this.objectiveService.getFormattedValue(dayValue * 20, this.objectiveService.addEdit.MetricValueType, this.objectiveService.addEdit.MetricValueTimeType);
        }
    }

    /**
     * Returns the placeholders for the range input fields.
     * */
    rangeInputPlaceholder() {
        switch (this.objectiveService.addEdit.MetricValueType) {
            case 0: // Currency
                return "0.00";
            case 1: // Number
                return "0";
            case 2: // Percent
                return "0";
            case 3: // Time
                switch (this.objectiveService.addEdit.MetricValueTimeType) {
                    case 0: // None
                    case 1: // Second
                    case 2: // Minute
                    case 3: // Hour
                        return "0";
                    case 4: // Time
                        return "00:00:00";
                    default:
                        return "0";
                }
            default:
                return "0";
        }
    }

    /**
     * Returns the zero value displayed in the center of the gauge and at the opposite to "and up"
     * */
    gaugeFormattedZero() {
        switch (this.objectiveService.addEdit.MetricValueType) {
            case 0: // Currency
                return "0.00";
            case 1: // Number
                return "0";
            case 2: // Percent
                return "0%";
            case 3: // Time
                switch (this.objectiveService.addEdit.MetricValueTimeType) {
                    case 0: // None
                    case 1: // Second
                    case 2: // Minute
                    case 3: // Hour
                        return "0";
                    case 4: // Time
                        return "00:00:00";
                    default:
                        return "0";
                }
            default:
                return "0";
        }
    }

    /**
     * Returns the cleaned specified input of illegal characters and ensures that it is in the right format. Runs every time one is changed.
     * @param value 0 for Main/Day, 1 for Week, 2 for Month
     * @param index Index of the range input
     */
    cleanRangeInput(value: number, index: number) {
        // Get the correct value that we are going to be cleaning
        let input;
        let objectiveDetail = this.objectiveService.addEdit.editedObjectives[this.objectiveService.addEdit.selectedObjective].ObjectiveDetails[index];
        switch (value) {
            case 0:
                input = objectiveDetail.dayMinValue;
                break;
            case 1:
                input = objectiveDetail.weekMinValue;
                break;
            case 2:
                input = objectiveDetail.monthMinValue;
                break;
        }

        // Remove all characters except numbers, periods and colons
        input = input.replace(/[^\d.:]/g, '');

        setTimeout(() => {
            this.cdr.detectChanges();
        }, 1);

        return this.objectiveService.getFormattedValue(input, this.objectiveService.addEdit.MetricValueType, this.objectiveService.addEdit.MetricValueTimeType);
    }

    onTimeInput(event: Event, level: number, index: number): void {
        const input = event.target as HTMLInputElement;
        let value = input.value;

        const objDetail = this.objectiveService.addEdit.editedObjectives[this.objectiveService.addEdit.selectedObjective].ObjectiveDetails[index];
        const inputType = this.objectiveService.addEdit.MetricValueType;
        const timeType = this.objectiveService.addEdit.MetricValueTimeType;

        if (level === 0) objDetail.dayMinValue = value;
        if (level === 1) objDetail.weekMinValue = value;
        if (level === 2) objDetail.monthMinValue = value;

        const timerKey = `${level}-${index}`;

        if (this.inputTimers[timerKey]) {
            clearTimeout(this.inputTimers[timerKey]);
        }

        const delay = (inputType !== 3 || (inputType === 3 && timeType !== 4)) ? 2000 : 4000;

        this.inputTimers[timerKey] = setTimeout(() => {
            if (inputType !== 3 || (inputType === 3 && timeType !== 4)) {
                if (value.includes('.')) {
                    if (value.startsWith('.')) {
                        value = value.slice(1); 
                    } else if (value.endsWith('.')) {
                        value = value.slice(0, -1); 
                    }

                    if (value.includes('.')) {
                        const parts = value.split('.');
                        const integer = parts[0];
                        const decimal = parts[1] || '';

                        if (decimal.length === 0) {
                            value = integer;
                        } else {
                            value = integer + '.' + decimal.slice(0, 2);
                        }
                    }

                    input.value = value;

                    if (level === 0) objDetail.dayMinValue = value;
                    if (level === 1) objDetail.weekMinValue = value;
                    if (level === 2) objDetail.monthMinValue = value;
                }
            } else {
                const formatted = this.cleanRangeInput(level, index);

                if (level === 0) objDetail.dayMinValue = formatted;
                if (level === 1) objDetail.weekMinValue = formatted;
                if (level === 2) objDetail.monthMinValue = formatted;
            }

            this.cdr.detectChanges();
            delete this.inputTimers[timerKey];
        }, delay);
    }


    validateInput(event: KeyboardEvent): void {
        const allowedChars = '0123456789';
        const char = event.key;

        const inputType = this.objectiveService.addEdit.MetricValueType;
        const timeType = this.objectiveService.addEdit.MetricValueTimeType;

        const input = event.target as HTMLInputElement;
        const currentValue = input.value;
        const cursorPosition = input.selectionStart || 0;

        if (allowedChars.includes(char)) {
            const pointIndex = currentValue.indexOf('.');
            if (
                pointIndex !== -1 &&
                cursorPosition > pointIndex &&
                currentValue.substring(pointIndex + 1).length >= 2
            ) {
                event.preventDefault();
            }
            return;
        }

        if (
            char === '.' &&
            (inputType !== 3 || (inputType === 3 && timeType !== 4)) &&
            !currentValue.includes('.')
        ) {
            return;
        }

        if (
            char === ':' &&
            inputType === 3 &&
            timeType === 4 &&
            (currentValue.match(/:/g) || []).length < 2
        ) {
            return;
        }

        event.preventDefault();
    }


    /** Run on save attempt. Checks to ensure that inputted values make sense. */
    verifyGaugeInputs(editedObjective) {
        let lastDay;
        let lastWeek;
        let lastMonth;

        if (editedObjective.ObjectiveDetails.length == 0 || editedObjective.ObjectivePaletteID == 0)
            return 8; // missing objective details or paletteID

        for (let i = 0; i < editedObjective.ObjectiveDetails.length; i++) {
            let objectiveDetail = editedObjective.ObjectiveDetails[i];

            if (!objectiveDetail.dayMinValue || objectiveDetail.dayMinValue === "00:00:00")
                return 4; // Empty value

            if (this.objectiveService.addEdit.MetricValueType == 0 || this.objectiveService.addEdit.MetricValueType == 2) {
                // Currency or Percent must be > 0 
                if (!/^\d+(\.\d{1,2})?$/.test(objectiveDetail.dayMinValue)) return 3;
                if (parseFloat(objectiveDetail.dayMinValue) <= 0) return 3;
            } else if (this.objectiveService.addEdit.MetricValueType == 1) {
                // Number must be > 0 and valid)
                if (!/^\d+(\.\d{1,2})?$/.test(objectiveDetail.dayMinValue)) return 3;
                if (parseFloat(objectiveDetail.dayMinValue) <= 0) return 3;
            } else if (this.objectiveService.addEdit.MetricValueType == 3 && this.objectiveService.addEdit.MetricValueTimeType == 4) {
                // Must be time format HH:MM:SS
                if (!/^\d+:[0-5][0-9]:[0-5][0-9]$/.test(objectiveDetail.dayMinValue)) return 3;
            } else if (this.objectiveService.addEdit.MetricValueType == 3 && this.objectiveService.addEdit.MetricValueTimeType != 4) {
                if (!/^\d+(\.\d{1,2})?$/.test(objectiveDetail.dayMinValue)) return 3;
                if (parseFloat(objectiveDetail.dayMinValue) <= 0) return 3;
            } else {
                // Must be whole number > 0
                let dayValue = Number(objectiveDetail.dayMinValue);
                if (isNaN(dayValue) || dayValue <= 0) return 3;
            }

            let dayValue = objectiveDetail.dayMinValue;
            if (this.objectiveService.addEdit.MetricValueType == 3 && this.objectiveService.addEdit.MetricValueTimeType == 4) {
                const [hh, mm, ss] = dayValue.split(':').map(n => parseInt(n, 10));
                dayValue = (hh * 3600) + (mm * 60) + ss;
            }
            dayValue = Number(dayValue);

            if (i > 0 && dayValue >= lastDay)
                return 7; // Out of order

            lastDay = dayValue;

            if (this.objectiveService.addEdit.MetricObjectiveType == 0) {
                if (!objectiveDetail.weekMinValue || !objectiveDetail.monthMinValue ||
                    objectiveDetail.weekMinValue === "00:00:00" || objectiveDetail.monthMinValue === "00:00:00")
                    return 4; // Empty value

                if (this.objectiveService.addEdit.MetricValueType == 0 || this.objectiveService.addEdit.MetricValueType == 2) {
                    if (!/^\d+(\.\d{1,2})?$/.test(objectiveDetail.weekMinValue) ||
                        !/^\d+(\.\d{1,2})?$/.test(objectiveDetail.monthMinValue)) return 3;
                    if (parseFloat(objectiveDetail.weekMinValue) <= 0 || parseFloat(objectiveDetail.monthMinValue) <= 0) return 3;
                } else if (this.objectiveService.addEdit.MetricValueType == 1) {
                    if (!/^\d+(\.\d{1,2})?$/.test(objectiveDetail.weekMinValue) ||
                        !/^\d+(\.\d{1,2})?$/.test(objectiveDetail.monthMinValue)) return 3;
                    if (parseFloat(objectiveDetail.weekMinValue) <= 0 || parseFloat(objectiveDetail.monthMinValue) <= 0) return 3;
                } else if (this.objectiveService.addEdit.MetricValueType == 3 && this.objectiveService.addEdit.MetricValueTimeType == 4) {
                    if (!/^\d+:[0-5][0-9]:[0-5][0-9]$/.test(objectiveDetail.weekMinValue) ||
                        !/^\d+:[0-5][0-9]:[0-5][0-9]$/.test(objectiveDetail.monthMinValue)) return 3;
                } else if (this.objectiveService.addEdit.MetricValueType == 3 && this.objectiveService.addEdit.MetricValueTimeType != 4) {
                    if (!/^\d+(\.\d{1,2})?$/.test(objectiveDetail.weekMinValue) ||
                        !/^\d+(\.\d{1,2})?$/.test(objectiveDetail.monthMinValue)) return 3;
                    if (parseFloat(objectiveDetail.weekMinValue) <= 0 || parseFloat(objectiveDetail.monthMinValue) <= 0) return 3;
                }else {
                    let weekValue = Number(objectiveDetail.weekMinValue);
                    let monthValue = Number(objectiveDetail.monthMinValue);
                    if (isNaN(weekValue) || weekValue <= 0 || isNaN(monthValue) || monthValue <= 0) return 3;
                }

                let weekValue = objectiveDetail.weekMinValue;
                let monthValue = objectiveDetail.monthMinValue;
                if (this.objectiveService.addEdit.MetricValueType == 3 && this.objectiveService.addEdit.MetricValueTimeType == 4) {
                    const [wh, wm, ws] = weekValue.split(':').map(n => parseInt(n, 10));
                    const [mh, mm, ms] = monthValue.split(':').map(n => parseInt(n, 10));

                    weekValue = (wh * 3600) + (wm * 60) + ws;
                    monthValue = (mh * 3600) + (mm * 60) + ms;
                }
                weekValue = Number(weekValue);
                monthValue = Number(monthValue);

                if (i > 0 && (weekValue >= lastWeek || monthValue >= lastMonth))
                    return 7; // Out of order

                lastWeek = weekValue;
                lastMonth = monthValue;
            }
        }

        return 0;
    }

    public getTypes():string{
        let types = "emp,rec,agent_att";

        if(this.objectiveService.addEdit.assignedGroups.coreAssignAtType == 'emp'){
            types += ",r_assign_all";
        }
        else{
            types += ",e_assign_all";
        }

        return types;
    }

    public refreshAssignTool(): void {
        if(this.assignTool){
            this.assignTool = false;
            this.cdr.detectChanges();
            this.assignTool = true;
            this.cdr.detectChanges();
        }
        else{
            this.assignTool = true;
            this.cdr.detectChanges();
        }
    }
}
